/* tslint:disable:typedef-whitespace no-trailing-whitespace */

import {
  TaskUpdate,
  TaskUpdateType
}                    from '@/models/task.update';
import { basename }  from '@/util/util';

/**
 *
 * @class TaskMergeDiamondCrossings
 *
 * @brief incremental progress reporting on merging diamond crossings into a scenario
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      February 2024
 *
 */
export class TaskMergeDiamondCrossings extends TaskUpdate {

  /**  the blob key for input scenario (read only) */
  public scenario: string;

  /**  the blob key for the diamond crossings */
  public crossings: string;

  /**  the blob key for the scenario being updated */
  public merged: string;

  /** the icon to use for the file type */
  public icon: string;

  /** the number of steps so far */
  public steps: number;

  /** the total number of steps */
  public total: number;

  /** what to use for the label (override) */
  public label: string;

  /**
   * standard constructor, you have to uniquely identify the task progress stream (id)
   * and provide the type of progress update (type).
   *
   * @param id        the unique id of the task progress stream to clear (the context)
   * @param scenario  blob key for the input scenario (read only)
   * @param crossings blob key for the diamond crossings
   * @param merged    blob key for scenario being updated
   * @param icon      the resource path to use for the icon
   * @param steps     the steps completed so far
   * @param label     summary/title to use
   * @param total     total number of steps
   *
   */
  constructor(
    id: string,
    scenario: string,
    crossings: string,
    merged: string,
    steps: number=0,
    label: string='',
    icon: string='blob-diamond-32.png',
    total: number=5) {

    super(id, TaskUpdateType.Progress,(steps / total) * 100.0);

    this.scenario  = scenario;
    this.crossings = crossings;
    this.merged    = merged;
    this.icon      = icon;
    this.steps     = steps;
    this.total     = total;
    this.label     = label;

  }

  /** subclasses that can render their own update should return non-empty HTML */
  render(): string {

    if (!this.label || this.label.length == 0) {

      this.label = basename(this.merged);
    }

    return `
<div class="task-file-upload-sub-panel">

  <div style="display: inline-block; width: 32px;">
    <img alt="merging diamond crossings, in progress..." class="tsp-icon" src="/assets/images/blob-icons/${this.icon}" width="32"></img>
  </div>

  <div style="display: inline-block; width: calc(100% - 40px);">

    <div style="display: inline-block;">
      <span class="tsp-label">${this.label}</span>
    </div>

    <div class="tsp-progress-border">
      <div class="tsp-progress-bar" style="width: ${this.progress.toFixed(2)}%"></div>
    </div>

    <div style="display: block;">
      <span class="tsp-size">[Merge] ${this.steps} of ${this.total}</span>
    </div>

  </div>

</div>
`;


  }


}
